export default __webpack_public_path__ + "static/media/magazine3.51221960.jpg";